import { Component, Input } from "@angular/core";
import { PonderDataClient } from "@apiserver-rest/ponder-data-client";
import { AddFriendResponse, UserRelationship, UserRelationshipType } from "@apiserver-rest/ponder-data-client-base";
import { AuthSession } from "@ponder-core/auth/auth-session";
import { AuthService } from "@ponder-core/auth/auth.service";
import { BusySpinComponent } from "@ponder-shared/components/busy-spin.component";
import { SvgIcon, SvgIconMap } from "@ponder-shared/utils/svgIcons";
import { take } from "rxjs";

@Component({
    selector: "profile-relationship-status",
    imports: [BusySpinComponent],
    templateUrl: "./profile-relationship-status.component.html"
})
export class ProfileRelationshipStatusComponent {
    @Input({ required: true }) public userId!: string;
    @Input({ required: true }) public isOwnProfile!: boolean;
    @Input({ required: true }) public relationship?: UserRelationship;

    public isFriend: boolean = false;
    public isPending: boolean = false;
    public canAdd: boolean = false;
    public friendUrl?: string;
    public isProcessing: boolean = false;

    public friendSvgIcon: string = SvgIconMap.get(SvgIcon.Friends)!;

    constructor(private ponderDataClient: PonderDataClient, private auth: AuthService) {

    }

    public ngOnInit(): void {
        if (this.isOwnProfile) {
            return;
        }

        this.auth.getSessionAsync().then((authSession?: AuthSession) => {
            if (authSession?.username) {
                this.friendUrl = `/user/${authSession.username}/friends`;

                if (this.relationship) {
                    switch (this.relationship.type) {
                        case UserRelationshipType.Friends:
                            this.isFriend = true;
                            break;
        
                        case UserRelationshipType.Pending:
                            this.isPending = true;
                            break;
        
                        case UserRelationshipType.None:
                            this.canAdd = true;
                            break;
        
                        default:
                            break;
                    }
                } else {
                    this.canAdd = true;
                }
            }
        });
    }

    public onAddFriendClicked(): void {
        if (this.isProcessing) {
            return;
        }

        this.isProcessing = true;

        this.ponderDataClient
            .userFriendAdd(this.userId)
            .pipe(take(1))
            .subscribe({
                next: (response: AddFriendResponse) => {
                    if (response.success) {
                        this.canAdd = false;
                        this.isPending = true;
                        this.isFriend = false;
                    }
                }
            })
            .add(() => { this.isProcessing = false; });
    }
}